import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery'; 
import Isotope from 'isotope-layout';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-autoplay.css';
import 'lightgallery/css/lg-share.css';
import 'lightgallery/css/lg-rotate.css';
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgAutoplay from "lightgallery/plugins/autoplay";
import lgVideo from "lightgallery/plugins/video";
import lgShare from "lightgallery/plugins/share";
import lgRotate from "lightgallery/plugins/rotate";

const CertificateMainContent = () => {
    // init one ref to store the future isotope object
    const isotope = React.useRef()
    // store the filter keyword in a state
    const [filterKey, setFilterKey] = React.useState('*')

    // initialize an Isotope object with configs
    React.useEffect(() => {
        isotope.current = new Isotope('.filter-container', {
            itemSelector: '.filter-item',
            layoutMode: 'fitRows',
        })
        // cleanup
        return () => isotope.current.destroy();
    }, [])

    // handling filter key change
    React.useEffect(() => {
        filterKey === '*' ? isotope.current.arrange({ filter: `*` }) : isotope.current.arrange({ filter: `.${filterKey}` })
    }, [filterKey])

    const handleFilterKeyChange = key => () => setFilterKey(key)


    React.useEffect(() => {    // change is-checked class on buttons
$(".button-group").each(function (i, buttonGroup) {
    var $buttonGroup = $(buttonGroup);
    $buttonGroup.on("click", "button", function () {
      $buttonGroup.find(".is-checked").removeClass("is-checked");
      $(this).addClass("is-checked");
    });
  });
}, [])
    return (
        <>
            <div className="iq-portfolio-page overview-block-ptb overview-block-pb5 certificate_sec">
                <div className="container">
                    <div className="row mt-3 mb-5 button-group filter-button-group">
                        <div className="col d-flex justify-content-center button-group">
                            <button type="button" onClick={handleFilterKeyChange('*')} className="btn btn-lg btn-secondary  mx-1 px-3 is-checked" >
                                All
                            </button>
                            <button type="button" onClick={handleFilterKeyChange('cComp')} className="btn btn-lg btn-secondary  mx-1 px-3" >
                                Certificate of Compliance
                            </button>
                            <button type="button" onClick={handleFilterKeyChange('cUdyam')} className="btn btn-lg btn-secondary  mx-1 px-3" >
                                Udyam Registration Certificate
                            </button>
                            <button type="button" onClick={handleFilterKeyChange('cRegistration')} className="btn btn-lg btn-secondary  mx-1 px-3" >
                                Certificate of Registration
                            </button>
                            <button type="button" onClick={handleFilterKeyChange('ITCA')} className="btn btn-lg btn-secondary  mx-1 px-3">
                                ITCA Membership
                            </button>
                        </div>
                    </div>
                    <div className='filter-container'>
                        <div className="row">
                            <div className="col-lg-6 col-md-6 cComp mb-3 filter-item certificateFilterCSS">
                                <div className="product-item">
                                    <div className="product-img" id="lightgallery">
                                        <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                            <a href="assets/certificate-img/cmmi3.webp" data-lightbox="image-1">
                                                <img src="assets/certificate-img/cmmi3.webp"
                                                    className="img-fluid mx-auto" alt="Project Screens"
                                                />
                                            </a>
                                        </LightGallery>
                                    </div>
                                    <div className="product-content text-center py-3">
                                        {" "}
                                        <span className="d-block ">CMMI - Maturity Level 3</span>{" "}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 ITCA mb-3 filter-item certificateFilterCSS">
                                <div className="product-item">
                                    <div className="product-img">
                                        <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                            <a href="assets/certificate-img/itca.webp" data-lightbox="image-1">
                                                <img
                                                    src="assets/certificate-img/itca.webp"
                                                    className="img-fluid mx-auto" alt="Project Screens"
                                                />
                                            </a>
                                        </LightGallery>
                                    </div>
                                    <div className="product-content text-center py-3">
                                        {" "}
                                        <span className="d-block">Certificate of ITCA Membership</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 cRegistration mb-3 filter-item certificateFilterCSS">
                                <div className="product-item">
                                    <div className="product-img">
                                        <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                            <a
                                                href="assets/certificate-img/449-alobha-technologies-private-limited.webp"
                                                data-lightbox="image-1"
                                            >
                                                <img
                                                    src="assets/certificate-img/449-alobha-technologies-private-limited.webp"
                                                    className="img-fluid mx-auto" alt="Project Screens"
                                                />
                                            </a>
                                        </LightGallery>
                                    </div>
                                    <div className="product-content text-center py-3">
                                        {" "}
                                        <span className="d-block ">ITSMS ISO/IEC</span>{" "}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 cRegistration mb-3 filter-item certificateFilterCSS">
                                <div className="product-item">
                                    <div className="product-img">
                                        <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                            <a href="assets/certificate-img/9001.webp" data-lightbox="image-1">
                                                <img
                                                    src="assets/certificate-img/9001.webp"
                                                    className="img-fluid mx-auto" alt="Project Screens"
                                                />
                                            </a>

                                        </LightGallery>
                                    </div>
                                    <div className="product-content text-center py-3">
                                        {" "}
                                        <span className="d-block ">ISO 9000:2015</span>{" "}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 cRegistration mb-3 filter-item certificateFilterCSS">
                                <div className="product-item">
                                    <div className="product-img">
                                        <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                            <a href="assets/certificate-img/14001.webp" data-lightbox="image-1">
                                                <img
                                                    src="assets/certificate-img/14001.webp"
                                                    className="img-fluid mx-auto" alt="Project Screens"
                                                />
                                            </a>
                                        </LightGallery>
                                    </div>
                                    <div className="product-content text-center py-3">
                                        {" "}
                                        <span className="d-block ">ISO 14001:2015</span>{" "}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 cRegistration mb-3 filter-item certificateFilterCSS">
                                <div className="product-item">
                                    <div className="product-img">
                                        <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                            <a href="assets/certificate-img/27001.webp" data-lightbox="image-1">
                                                <img
                                                    src="assets/certificate-img/27001.webp"
                                                    className="img-fluid mx-auto" alt="Project Screens"
                                                />
                                            </a>
                                        </LightGallery>
                                    </div>
                                    <div className="product-content text-center py-3">
                                        {" "}
                                        <span className="d-block ">ISO 27001:2013</span>{" "}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 cUdyam mb-3 filter-item certificateFilterCSS">
                                <div className="product-item">
                                    <div className="product-img">
                                        <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                            <a
                                                href="assets/certificate-img/udyam-registration-certificate-alobha-technologies.webp"
                                                data-lightbox="image-1"
                                            >
                                                <img
                                                    src="assets/certificate-img/udyam-registration-certificate-alobha-technologies.webp"
                                                    className="img-fluid mx-auto" alt="Project Screens"
                                                />
                                            </a>
                                        </LightGallery>
                                        {/* <img src="assets/certificate-img/Udyam-Registration-Certificate-Alobha-Technologies-1.webp" class="img-fluid mx-auto"> */}
                                    </div>
                                    <div className="product-content text-center py-3">
                                        {" "}
                                        <span className="d-block">Udyam Registration Certificate</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 cUdyam mb-3 filter-item certificateFilterCSS">
                                <div className="product-item">
                                    <div className="product-img">
                                        <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                            <a
                                                href="assets/certificate-img/alobha_msme-certificate.webp"
                                                data-lightbox="image-1"
                                            >
                                                <img
                                                    src="assets/certificate-img/alobha_msme-certificate.webp"
                                                    className="img-fluid mx-auto" alt="Project Screens"
                                                />
                                            </a>
                                        </LightGallery>
                                        {/* <img src="assets/certificate-img/Alobha_MSME-Certificate.webp" class="img-fluid mx-auto"> */}
                                    </div>
                                    <div className="product-content text-center py-3">
                                        {" "}
                                        <span className="d-block">MSME Registration Certificate</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default CertificateMainContent